import { ITINERARY_ITEM_ID_PREFIX } from '~/stores/tpv2/overviewProgressStore';

export const STICKY_BAR_HEIGHT_PX = 149;
export const STICKY_BAR_BREAKPOINT_PX = 1000;
const CARD_SCROLL_GAP_PX = 16;

export const scrollItineraryCardIntoView = (itemId: number): boolean => {
  const card = document.getElementById(`${ITINERARY_ITEM_ID_PREFIX}${itemId}`);
  if (!card) return false;
  const barHeight = globalThis.matchMedia(`(min-width: ${STICKY_BAR_BREAKPOINT_PX}px)`).matches
    ? STICKY_BAR_HEIGHT_PX
    : 0;
  globalThis.scrollBy({ top: card.getBoundingClientRect().top - barHeight - CARD_SCROLL_GAP_PX, behavior: 'smooth' });
  return true;
};
